import { LinkId } from '../../../../common/AnalyticsContext/LinkId';
import { applyTrackingId } from '../../../../common/AnalyticsContext/applyTrackingId';
import { useNoFilter, useResetFilters } from '../../../FilterContainer/filters/useResetFilters';
import {
  Hint,
  HintHeader,
  HintListItemLink,
  Message,
  EndOfResultsContainer,
  Card,
  StyledImage,
} from './EndOfResults.styles';

export const EndOfResults = () => {
  const handleClick = useResetFilters();

  const noFilter = useNoFilter();

  return (
    <EndOfResultsContainer>
      <Card>
        <StyledImage />
        <Message>
          <HintHeader>Expand your search for more relevant results.</HintHeader>
          <Hint>
            Try using different search keywords
            {noFilter && `.`}
            {!noFilter && (
              <>
                {' '}
                or{' '}
                <HintListItemLink
                  onClick={handleClick}
                  {...applyTrackingId(LinkId.END_OF_RESULTS_RESET_FILTER)}
                >
                  resetting your filters.
                </HintListItemLink>
              </>
            )}
          </Hint>
        </Message>
      </Card>
    </EndOfResultsContainer>
  );
};
